import {RestService} from "@sinossi/mates-react-library";

export class AccountServices {
    static getAssetLikes = (callback: any, catchCallback: any) => {
        RestService
            .get<any>(`/api/account/likes`)
            .then(callback)
            .catch(catchCallback)
    }

    static hideDashboardResearchMessage = (accountId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`api/${accountId}/hide_research_info`, false)
            .then(callback)
            .catch(catchCallback)
    }
}
